import { Injectable } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AbstractForm } from '@core/abstract/form';
import { PaymentType } from '@shared/data/payment-type';
import { DECIMAL_NUMBER_PATTERN } from '../../../app.constants';
import { PrintedTicketFormField } from '../../../features/printed-ticket/printed-ticket-form/printed-ticket-form.service';

export enum AddCardFormField {
    MediumType = 'mediumType',
    MediumN = 'mediumN',
    Mobnum = 'mobnum',
    TermCode = 'termCode',
    TopupSum = 'topupSum',
    AddCardForClient = 'addCardForClient',
    // eslint-disable-next-line no-shadow
    PaymentType = 'paymentType',
    PaymentAccepted = 'paymentAccepted',
}

export type AddCardFormModel = {
    [AddCardFormField.MediumType]: FormControl<number>;
    [AddCardFormField.TopupSum]: FormControl<number>;
    [AddCardFormField.Mobnum]: FormControl<string>;
    [AddCardFormField.TermCode]: FormControl<string>;
    [AddCardFormField.MediumN]: FormControl<string>;
    [AddCardFormField.PaymentAccepted]: FormControl<boolean>;
    [AddCardFormField.AddCardForClient]: FormControl<boolean>;
    [AddCardFormField.PaymentType]: FormControl<PaymentType>;
};

@Injectable()
export class AddCardFormService extends AbstractForm<AddCardFormField, AddCardFormModel> {
    public createReactiveForm(): FormGroup<AddCardFormModel> {
        this.build({
            [AddCardFormField.MediumType]: new FormControl<number>(null, [Validators.required]),
            [AddCardFormField.MediumN]: new FormControl<string>(null, [Validators.required]),
            [AddCardFormField.TopupSum]: new FormControl<number>(null, [
                Validators.required,
                Validators.pattern(DECIMAL_NUMBER_PATTERN),
            ]),
            [AddCardFormField.Mobnum]: new FormControl<string>(null, []),
            [AddCardFormField.TermCode]: new FormControl<string>(null, [Validators.required]),
            [AddCardFormField.PaymentAccepted]: new FormControl<boolean>(null, [Validators.requiredTrue]),
            [AddCardFormField.AddCardForClient]: new FormControl<boolean>(null, []),
            [PrintedTicketFormField.PaymentType]: new FormControl<PaymentType>(PaymentType.Cash, [Validators.required]),
        });

        this.defineMechanics();

        return this.form;
    }

    private defineMechanics(): void {
        this.watchForValueChanges(AddCardFormField.AddCardForClient).subscribe((value: boolean) => {
            if (!value) {
                this.getControlByPath(AddCardFormField.Mobnum).removeValidators([Validators.required]);
            } else {
                this.getControlByPath(AddCardFormField.Mobnum).addValidators([Validators.required]);
                this.getControlByPath(AddCardFormField.Mobnum).updateValueAndValidity({
                    onlySelf: true,
                });
            }
        });

        this.watchForValueChanges(AddCardFormField.AddCardForClient).subscribe((withRegister: boolean) => {
            if (withRegister) {
                this.getControlByPath(AddCardFormField.TopupSum).removeValidators([Validators.required]);
            } else {
                this.getControlByPath(AddCardFormField.TopupSum).addValidators([Validators.required]);
            }

            this.getControlByPath(AddCardFormField.TopupSum).updateValueAndValidity({
                onlySelf: true,
            });
        });
    }
}
